/* globals ScrollUtil */

import { component } from 'common/util/ComponentDecorator';
import './checkout-shipping.scss';

@component
export default class CheckoutShipping {
	static classname = 'checkout-shipping';

	constructor($shipping) {
		this.$shipping = $shipping;
		this.init();
		this.decorate();
		this.initEventListeners();
		/*this.addClass();*/

	}

	init = () => {
		const $errorInputs = this.$shipping.find('input.error');
		if ($errorInputs.length) {
			ScrollUtil.scrollTo($errorInputs.offset().top - 150);
		}
	};

	decorate = () => {
		this.$shipping.find('input').each(function() {
			const $input = $(this);
			$input.data('label', $input.closest('.field').find('span').html());
			$input.addClass('js-formgroup-decorator');
		});
	};

	initEventListeners = () => {
		const shippingBlock = this.$shipping;
		this.$shipping.find('.checkout-shipping-method').on('click', function() {
			const $this = $(this);
			const valArr = [];
			valArr.push($this.find('.checkout-shipping-method__control').val());
			$('input[name="shipping_id"]').val(valArr).trigger('change');

		});

		this.$shipping.on('reset@checkout-shipping-methods', function() {
			var methods = shippingBlock.find('.checkout-shipping-method').not('.checkout-shipping-method_hidden').not('.checkout-shipping-method_error');

			methods.first().trigger('click');
		})
	};

	addClass = () => {
		const shippingSelects = this.$shipping.find('select[name*="[address.shipping]"]');

		shippingSelects.addClass('js-select-decorator');
	}

};
